// src/components/InstagramEmbed.js
import React, { useEffect } from 'react';

const InstagramEmbed = ({ embedCodes }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('src', '//www.instagram.com/embed.js');
    script.setAttribute('async', '');
    document.body.appendChild(script);

    // Esta função é para reprocessar os embeds após o React renderizar o HTML
    // E, mais importante, para que o script do Instagram renderize os iframes
    const reprocessEmbeds = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    const timeoutId = setTimeout(reprocessEmbeds, 500);

    return () => {
      document.body.removeChild(script);
      clearTimeout(timeoutId);
    };
  }, [embedCodes]);

  return (
    <div className="row justify-content-center">
      {embedCodes.map((code, index) => (
        <div key={index} className="col-md-4 col-sm-12 mb-4">
          <div
            style={{
              height: '500px', // Altura fixa para o container do embed
              overflowY: 'auto', // Adiciona barra de rolagem vertical se necessário
              border: '1px solid #ddd',
              borderRadius: '8px',
              backgroundColor: '#fff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              padding: '10px',
              position: 'relative', // Importante para posicionamento de filhos
            }}
          >
            {/* O embed do Instagram será colocado aqui.
                Vamos envolver o dangerouslySetInnerHTML em outra div para ajudar a controlar o tamanho. */}
            <div
              style={{
                // Estilos para o conteúdo do embed dentro da div rolavel
                width: '100%', // Ocupa a largura total da div pai
                // Remova qualquer altura fixa ou máxima aqui, deixe o Instagram controlar a altura natural
                // E o overflow da div pai irá gerenciar a rolagem
              }}
              dangerouslySetInnerHTML={{ __html: code }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default InstagramEmbed;